import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { api } from "../lib/api";
import { Loader } from "../components/ui-bits";
import { MediaImage } from "../components/MediaImage";

export default function BlogDetail() {
  const { slug } = useParams();
  const [item, setItem] = useState(null);

  useEffect(() => {
    setItem(null);
    api.get(`/blog/${slug}`).then((r) => setItem(r.data)).catch(() => setItem(false));
  }, [slug]);

  if (item === null) return <Loader label="Loading article" />;
  if (item === false) return <div className="max-w-3xl mx-auto px-6 py-40 text-center text-slate-400" data-testid="blog-notfound">Article not found. <Link to="/blog" className="text-emerald-400">Back to Blog</Link></div>;

  return (
    <article className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-20" data-testid="blog-detail-page">
      <Link to="/blog" data-testid="blog-back-link" className="inline-flex items-center gap-2 text-slate-400 hover:text-emerald-400 text-sm font-mono mb-8">
        <ArrowLeft className="w-4 h-4" /> Blog
      </Link>
      <p className="font-mono text-sm text-emerald-400 mb-3">{item.date}</p>
      <h1 className="text-3xl sm:text-4xl lg:text-5xl font-display font-extrabold text-white tracking-tight leading-tight mb-8">{item.title}</h1>
      {item.image_url && (
        <div className="rounded-2xl overflow-hidden mb-10 border border-slate-800">
          <MediaImage src={item.image_url} alt={item.title} className="w-full max-h-[70vh] object-cover" />
        </div>
      )}
      <div className="prose-emerald max-w-none">
        {(item.body && item.body.length ? item.body : [item.excerpt]).filter(Boolean).map((p, i) => <p key={i}>{p}</p>)}
      </div>
    </article>
  );
}
